<template>
    <div id = 'myProfile'> 
        <div class = 'container preisfinderBodyConstraint'>
           <div class = 'row card-panel'>
                <h4 class="center">Profile</h4>
                            
                <form class="col s12">
                    <div class="input-field col s12">
                        <input type="text" id="firmenname" v-model="user.firmenname" />
                        <label for="firmenname">firmenname</label>
                    </div>

                    <div class="input-field col s6">
                        <input id="vorname" type="text" v-model="user.vorname" />
                        <label for="vorname">Vorname*</label>
                    </div>
                    <div class="input-field col s6">
                        <input id="name" type="text" v-model="user.name" />
                        <label for="name">Name*</label>
                    </div>

                    <div class="input-field col s12">
                        <input id="position" type="text" v-model="user.position" />
                        <label for="position">Position*</label>
                    </div>

                    <div class="input-field col s6">
                        <input id="telefon" type="text" v-model="user.telefon" />
                        <label for="telefon">Telefon*</label>
                    </div>
                    <div class="input-field col s6">
                        <input id="mobil" type="text" v-model="user.mobil" />
                        <label for="mobil">Mobil</label>
                    </div>

                    <div class="input-field col s6">
                        <input id="handelsregister" type="text" v-model="user.handelsregister" />
                        <label for="handelsregister">Handelsregister Nr. / Gewerbeschein-Nr.*</label>
                    </div>
                    <div class="input-field col s6">
                        <input id="website" type="text" v-model="user.website" />
                        <label for="website">Website</label>
                    </div>

                    <div class="input-field col s3">
                        <input id="strasse" type="text" v-model="user.strasse" />
                        <label for="strasse">Straße*</label>
                    </div>

                    <div class="input-field col s3">
                        <input id="plz" type="text" v-model="user.plz" />
                        <label for="plz">PLZ*</label>
                    </div>

                    <div class="input-field col s3">
                        <input id="ort" type="text" v-model="user.ort" />
                        <label for="ort">Ort*</label>
                    </div>

                    <div class="input-field col s3">
                        <select v-model="user.country">
                        <option value disabled selected>Country</option>
                        <option value="Deutschland">Deutschland</option>
                        <optgroup label="EU">
                            <option
                            v-for="country in user.countryList"
                            v-bind:key="country.id"
                            >{{ country.name }}</option>
                        </optgroup>
                        </select>
                    </div>

                    <div class="input-field col s6">
                        <input id="email" type="text" class="validate" v-model="user.email" />
                        <label for="email">E-Mail*</label>
                    </div>
                    <div class="input-field col s6">
                        <input id="password" type="password" class="validate" v-model="user.password" />
                        <label for="password">Password*</label>
                    </div>
                </form>

                <h5 class="teal-text text-darken-3">Firmenprofil*</h5>
                <p>
                <label>
                    <input name="group1" type="radio" value="Freier Händler" v-model="user.firmenprofil" />
                    <span>Freier Händler</span>
                </label>
                </p>
                <p>
                <label>
                    <input name="group1" type="radio" value="Vertragshändler" v-model="user.firmenprofil" />
                    <span>Vertragshändler</span>
                </label>
                </p>
                <p>
                <label>
                    <input name="group1" type="radio" value="Niederlassung" v-model="user.firmenprofil" />
                    <span>Niederlassung</span>
                </label>
                </p>
                <p>
                <label>
                    <input name="group1" type="radio" value="Hersteller" v-model="user.firmenprofil" />
                    <span>Hersteller</span>
                </label>
                </p>

                <div class="center-align">
                    <a class="btn black" v-on:click="updateBtnTapped" :style="{width: '200px'}">Update Profile 
                        <i v-if="isLoading" class="fa fa-spinner fa-spin"></i>
                    </a>
                </div>
           </div>
        </div>
    </div>
</template>

<script src='https://cdnjs.cloudflare.com/ajax/libs/materialize/1.0.0/js/materialize.min.js'></script>

<script>
import firebase from 'firebase'
import firebaseInit from "../components/firebaseInit";
export default {
    name: 'myProfile',
    data(){
        return {
            user: {
                firmenname: ' ',
                vorname: " ",
                name: " ",
                position: " ",
                telefon: " ",
                mobil: " ",
                handelsregister: " ",
                website: " ",
                strasse: " ",
                plz: " ",
                ort: " ",
                country: " ",
                countryList: [
                    { id: 1, name: "Austria" },
                    { id: 2, name: "Belgium" },
                    { id: 3, name: "Bulgaria" },
                    { id: 4, name: "Croatia" },
                    { id: 5, name: "Cyprus" },
                    { id: 6, name: "Czech" },
                    { id: 7, name: "Denmark" },
                    { id: 8, name: "Estonia" },
                    { id: 9, name: "Finland" },
                    { id: 10, name: "France" },
                    { id: 11, name: "Greece" },
                    { id: 12, name: "Hungary" },
                    { id: 13, name: "Ireland" },
                    { id: 14, name: "Italy" },
                    { id: 15, name: "Latvia" },
                    { id: 16, name: "Lithuania" },
                    { id: 17, name: "Luxembourg" },
                    { id: 18, name: "Malta" },
                    { id: 19, name: "Netherlands" },
                    { id: 20, name: "Poland" },
                    { id: 21, name: "Portugal" },
                    { id: 22, name: "Romania" },
                    { id: 23, name: "Slovakia" },
                    { id: 24, name: "Slovenia" },
                    { id: 25, name: "Spain" },
                    { id: 26, name: "Sweden" },
                    { id: 27, name: "UK" }
                ],

                email: " ",
                password: "",
                firmenprofil: " "
            },

            isLoading: false
        }
    },

    created(){
        this.fetchData()
    },

    watch: {
        // call again the method if the route changes
        '$route': 'fetchData'
    },

    mounted(){
        M.updateTextFields();
        var selectInit = document.querySelectorAll("select");
        var instances = M.FormSelect.init(selectInit, {});
    },

    methods:{
        fetchData(){
            const currentUserUID = firebase.auth().currentUser.uid
            const currentUserDoc = firebaseInit.collection("user").doc(currentUserUID);

            currentUserDoc.get().then((doc) =>  {
                if (doc.exists) {
                    this.user.firmenname = doc.data().firmenname
                    this.user.vorname = doc.data().vorname
                    this.user.name = doc.data().name
                    this.user.position = doc.data().position
                    this.user.telefon = doc.data().telefon
                    this.user.mobil = doc.data().mobil
                    this.user.handelsregister = doc.data().handelsregister
                    this.user.website = doc.data().website
                    this.user.strasse = doc.data().strasse
                    this.user.plz = doc.data().plz
                    this.user.ort = doc.data().ort
                    this.user.country = doc.data().country
                    this.user.email = doc.data().email
                    this.user.firmenprofil = doc.data().firmenprofil
                } else {
                    console.log("No such document!");
                }        
            }).catch(function(error) {
                console.log("Error getting document:", error);
            });
        },
        updateBtnTapped(){
            this.isLoading = true
            const currentUserUID = firebase.auth().currentUser.uid
            const currentUserDoc = firebaseInit.collection("user").doc(currentUserUID);

            currentUserDoc.get().then((doc) =>  {
                if (doc.exists) {
                    doc.ref.update({
                        firmenname: this.user.firmenname, 
                        vorname: this.user.vorname,
                        name: this.user.name,
                        position: this.user.position, 
                        telefon: this.user.telefon,
                        mobil: this.user.mobil, 
                        handelsregister: this.user.handelsregister, 
                        website: this.user.website, 
                        strasse: this.user.strasse, 
                        plz: this.user.plz, 
                        ort: this.user.ort, 
                        country: this.user.country, 
                        email: this.user.email,
                        firmenprofil: this.user.firmenprofil
                    }).then(() => {
                        this.isLoading = false
                        // M.toast({html: 'Profile updated!',  classes: 'rounded', displayLength: '2000'})
                    })
                } else {
                    console.log("No such document!");
                }        
            }).catch(function(error) {
                console.log("Error getting document:", error);
            });
        }
    }
}
</script>